export default __webpack_public_path__ + "static/media/Joshua-Allan-CV_2023.84f94a6a.pdf";